import * as R from "ramda";
import { api } from "../api/api";

/**
 * Spectre Motion measurement sets of a customer (GET /api/motion/customer/{id}/measurements).
 * 403 means the account has no BALL_MOTION entitlement: resolved as an empty
 * list so the header can simply not show the chip.
 */
export const getMotionMeasurements = (customerId) => {
  const { checkOffline, ajaxSession } = api;
  return R.pipeP(checkOffline, (offline) =>
    offline
      ? Promise.resolve({ measurements: [] })
      : ajaxSession(`motion/customer/${customerId}/measurements`, { type: "GET" }),
  )()
    .then((res) => (res && Array.isArray(res.measurements) ? res.measurements : []))
    .catch(() => []);
};
